import { render, staticRenderFns } from "./ReceiptsManage.vue?vue&type=template&id=71d960f4&scoped=true"
import script from "./ReceiptsManage.vue?vue&type=script&lang=js"
export * from "./ReceiptsManage.vue?vue&type=script&lang=js"
import style1 from "./ReceiptsManage.vue?vue&type=style&index=1&id=71d960f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d960f4",
  null
  
)

export default component.exports